import React from 'react';
import ColumnRules from './ColumnRules';

const ImportPlanosFinanceirosColumnsRules = () => {
  const rules = [
    {
      name: 'Nome_Plano_Financeiro',
      required: true,
      options: ['Nome do plano financeiro.'],
    },
    {
      name: 'Tipo',
      required: true,
      options: ['Tipo do plano financeiro.'],
    },
    {
      name: 'Valor',
      required: true,
      options: ['Valor do plano em numeros.'],
    },
    {
      name: 'Valor_Extenso',
      required: true,
      options: ['Valor do plano por extenso.'],
    },
    {
      name: 'Metodo_Pagto',
      required: true,
      options: ['Método de pagamento do plano.'],
    },
    {
      name: 'Conta_Gateway',
      required: true,
      options: ['Bandeira da conta do plano.'],
    },
    {
      name: 'Max_parcela_cartao',
      required: true,
      options: ['Numero máximo de parcelas do cartão.'],
    },
    {
      name: 'Data_Vencimento',
      required: true,
      options: ['Data de vencimento do plano.'],
    },
    {
      name: 'Inicio_Vigencia',
      required: true,
      options: ['Inicio de vigência do plano.'],
    },
    {
      name: 'Termino_Vigencia',
      required: true,
      options: ['Término de vigência do plano.'],
    },
    {
      name: 'Parcelas',
      required: true,
      options: ['Número de parcelas do plano.'],
    },
    {
      name: 'Parcelas_Extenso',
      required: true,
      options: ['Número por extenso de parcelas do plano.'],
    },
    {
      name: 'Fiadores',
      required: true,
      options: ['Plano exige fiadores?.'],
    },
    {
      name: 'Valor_Primeira_Parcela',
      required: true,
      options: ['Valor em numero da primeira parcela.'],
    },
    {
      name: 'Valor_Primeira_Parcela_Extenso',
      required: true,
      options: ['Valor por extenso da primeira parcela.'],
    },
    {
      name: 'Processo_Matricula',
      required: true,
      options: ['Nome do processo de matrícula associado.'],
    },
    {
      name: 'Ordem',
      required: true,
      options: ['Número da ordem do plano.'],
    },
    {
      name: 'Mensagem',
      required: true,
      options: ['Mensagem.'],
    },
    {
      name: 'Fies',
      required: true,
      options: ['Possui FIES ? Sim ou Não.'],
    },
    {
      name: 'Removido',
      required: true,
      options: ['Removido ? Sim ou Não.'],
    },
    {
      name: 'Primeira_Parcela_Dinamica',
      required: true,
      options: ['A primeira parcela é dinâmica? Sim ou Não'],
    },
    {
      name: 'Dias_Primeira_Parcela',
      required: true,
      options: ['Dias de validade da primeira parcela.'],
    },
    {
      name: 'Gerar_Boleto_Automatico',
      required: true,
      options: ['Gera boleto automaticamente? Sim ou Não.'],
    },
    {
      name: 'Permitir_Novo_Boleto',
      required: true,
      options: ['Permite um novo boleto? Sim ou Não.'],
    },
    {
      name: 'Mostrar_data_Venc_Todas_Parcelas',
      required: true,
      options: ['Deseja mostrar todas as parcelas vencidas? Sim ou Não.'],
    },
  ];

  return <ColumnRules rules={rules} />;
};

export default ImportPlanosFinanceirosColumnsRules;
